import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-airport',
  templateUrl: './airport.component.html',
  styleUrls: ['./airport.component.css']
})
export class AirportComponent implements OnInit {

  countryList = [];
  city = [];
  cityList = [];

  model = {
    'table_name': 'airport', 'airport_id': '0', 'airport_name': '', 'airport_name_en': '',
    'city_id': '', 'airport_code': '', 'comment': ''
  };

  country_model = { 'country_id': '' };

  Success_Msg; Error_Msg; Airport_Name_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<AirportComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Airport_Name_Msg').subscribe((res: string) => {
      this.Airport_Name_Msg = res;
    });

  }

  ngOnInit() {
    if (this.dialog_data != null) {
      this.model = this.dialog_data['0'];
      this.country_model = this.dialog_data['1'];
    }

    let query = this.queryList.all_country;
    let obj2 = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.countryList = data.data['list'];
      });

    query = this.queryList.all_city;
    obj2 = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.city = data.data['list'];
        if (this.dialog_data != null)
          this.getCity();
      });
  }

  getCity() {
    this.cityList = [];
    this.city.forEach(element => {
      if (element.country_id == this.country_model['country_id'])
        this.cityList.push(element);
    });
  }

  add() {
    if (this.model['airport_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['airport_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'airport_id': this.model['airport_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = {
              'status': data.status['type']
            };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['airport_name'] == '') {
      alert(this.Airport_Name_Msg);
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
